import React from 'react';
import logo from '../assets/logo.png';

export default function LocationSelection({ locations, onSelect, onLogout, onBack }) {
    return (
        <div className="min-h-screen flex items-center justify-center p-4">
            <div className="card w-full max-w-md glass-panel p-8 fade-in">
                <div className="text-center mb-8">
                    <img src={logo} alt="Raconsoft Logo" className="login-logo" />
                    <h1 className="text-2xl font-bold text-white mb-2">Kies Locatie</h1>
                    <p className="text-slate-400">Selecteer een locatie om verder te gaan</p>
                </div>

                <div className="space-y-4">
                    {locations.map((loc) => (
                        <button
                            key={loc}
                            onClick={() => onSelect(loc)}
                            className="w-full p-4 rounded-lg bg-slate-800/50 hover:bg-slate-700/50 border border-slate-700 hover:border-blue-500/50 transition-all group text-left flex items-center justify-between"
                        >
                            <span className="font-medium text-slate-200 group-hover:text-white">{loc}</span>
                            <span className="text-slate-500 group-hover:text-blue-400">→</span>
                        </button>
                    ))}
                </div>

                <div className="mt-8 pt-6 border-t border-slate-700/50 flex gap-4">
                    {onBack && (
                        <button
                            onClick={onBack}
                            className="flex-1 btn btn-sm bg-slate-700 hover:bg-slate-600 text-slate-200 border-slate-600"
                        >
                            ⬅️ Terug
                        </button>
                    )}
                    <button
                        onClick={onLogout}
                        className="flex-1 btn btn-sm bg-slate-700 hover:bg-slate-600 text-slate-200 border-slate-600"
                    >
                        Uitloggen
                    </button>
                </div>
            </div>
        </div>
    );
}
